import React, { useState, useEffect } from 'react'
import { Table, Modal, Toast } from 'react-bootstrap'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  deleteSingleUserActivity,
  fetchUserActivityAsync,
  deleteMultipleUserActivity,
} from './_redux/activity.api'
import { ActivityActions } from './_redux/activity.action'
import { Link } from 'react-router-dom'
import { userProfileInfoAsync } from '../Auth/_redux'

function Activity() {
  const dispatch = useDispatch()

  const [selectedService, setSelectedService] = useState()

  const {
    userActivities,
    refreshActivities,
    multiModal,
    singleModal,
    isLoading,
  } = useSelector((state) => state.activity, shallowEqual)

  const onOpenRemoveActivityModal = () => {
    dispatch(ActivityActions.openSingleModal())
  }

  const onCloseRemoveActivityModal = () => {
    dispatch(ActivityActions.closeSingleModal())
  }

  const onOpenRemoveAllActivitiesModal = () => {
    dispatch(ActivityActions.openMultipleModal())
  }

  const onCloseRemoveAllActivitiesModal = () => {
    dispatch(ActivityActions.closeMultipleModal())
  }

  const onRemoveClick = (id) => {
    setSelectedService(id)
    onOpenRemoveActivityModal()
  }

  const onRemoveActivity = () => {
    dispatch(deleteSingleUserActivity(selectedService))
  }

  const onRemoveAllActivity = () => {
    dispatch(deleteMultipleUserActivity())
  }

  useEffect(() => {
    if (refreshActivities) {
      dispatch(fetchUserActivityAsync())
    }
  }, [refreshActivities])

  const { user } = useSelector((state) => state.auth, shallowEqual)

  useEffect(() => {
    dispatch(userProfileInfoAsync(user._id))
  }, [])

  const [showA, setShowA] = useState(true)
  const toggleShowA = () => setShowA(!showA)

  return (
    <>
      <div className="row">
        {/* message pop up for KYC link begins*/}
        {user.kycStatus !== 'COMPLETED' ? (
          <div className="col-md-12 d-flex justify-content-center">
            <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
              <Toast.Body>
                <h2 className="kyc-toast-title">
                  Your KYC is not completed. Please complete it{' '}
                  <Link to="/kyc">
                    <span className="text-dark kyc-toast-title-link">here</span>{' '}
                  </Link>{' '}
                  in order to be able to buy gold.{' '}
                </h2>
              </Toast.Body>
            </Toast>
          </div>
        ) : (
          <div className="col-md-12 d-flex justify-content-center">
            <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
              <Toast.Body>
                <h2 className="kyc-toast-title">
                  {' '}
                  Click{' '}
                  <a
                    href={`http://rfid.victoreanum.com/?uid=${user._id}`}
                    target="_blank"
                  >
                    here
                  </a>{' '}
                  to buy gold.{' '}
                </h2>
              </Toast.Body>
            </Toast>
          </div>
        )}
        {/* message pop up for KYC link ends*/}

        <div className="col-md-12 d-flex justify-content-between flex-wrap flex-sm-nowrap">
          <div className="mr-1">
            <h5 className="inpg_ttl mr-5">Activity</h5>
          </div>
          <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
            <button
              type="button"
              className="btn btn-def btn_dlalactv"
              onClick={onOpenRemoveAllActivitiesModal}
            >
              Delete All the Activities
            </button>
          </div>
        </div>
        <div className="col-md-12 mt-5">
          <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn">
            <div className="tblmrgn mt-0">
              <Table hover responsive className="mb-0 default_table mrpdng_tbl">
                <thead>
                  <tr>
                    <th className="wd-120">Date and Time</th>
                    <th>Device</th>
                    <th>Browser</th>
                    {/* <th>IP Address</th> */}
                    <th className="wd-120"></th>
                  </tr>
                </thead>
                <tbody>
                  {userActivities.length > 0 &&
                    userActivities.map(
                      (item) =>
                        item.status === 'ACTIVE' && (
                          <tr key={item._id}>
                            <td>
                              {item.date
                                ? new Date(item.date)
                                    .toISOString()
                                    .substr(0, 10)
                                    .replace(/-/g, '/')
                                : '-'}
                            </td>
                            <td>{item.device}</td>
                            <td>{item.browser}</td>
                            {/* <td>{item.ipaddress}</td> */}
                            <td>
                              <button
                                type="button"
                                className="btn_new btn-sm rmv_btn"
                                onClick={() => onRemoveClick(item._id)}
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        ),
                    )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={singleModal}
        onHide={onCloseRemoveActivityModal}
        centered
        className="def_modal delete_modal modal_400"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure want to delete the activity?
            </p>
            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <button
                type="button"
                className="btn btn-def btn_pdng mr-3"
                onClick={onCloseRemoveActivityModal}
              >
                Keep
              </button>
              <button
                type="button"
                className="btn btn-delete btn_pdng"
                onClick={onRemoveActivity}
                disabled={isLoading}
              >
                Yes, Delete
                {isLoading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={multiModal}
        onHide={onCloseRemoveAllActivitiesModal}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure want to delete all the activities?
            </p>
            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <button
                type="button"
                className="btn btn-def btn_pdng mr-3"
                onClick={onCloseRemoveAllActivitiesModal}
              >
                Keep
              </button>
              <button
                type="button"
                className="btn btn-delete btn_pdng"
                onClick={onRemoveAllActivity}
                disabled={isLoading}
              >
                Yes, Delete
                {isLoading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Activity
